export const USER_STATUS = [
  { value: "有効", label: "有効"},
  { value: "承認待ち", label: "承認待ち"},
  { value: "退会済み", label: "退会済み"},
  { value: "一時停止", label: "一時停止"},
]

export const USER_STATUS_VALUE = {
  "有効": "1",
  "承認待ち": "2",
  "退会済み": "3",
  "一時停止": "4",
}

export const NOTIFICATION_STATUS = [
  { value: "", label: "すべて"},
  { value: "1", label: "送信済み"},
  { value: "2", label: "送信エラー"},
  { value: "3", label: "予約済み"}
]

export const NOTIFICATION_TYPE = [
  { value: "", label: "すべて"},
  { value: "1", label: "メンテナンス"},
  { value: "2", label: "ニュース"},
  { value: "3", label: "緊急連絡"}
]

export const NOTIFICATION_STATUS_TEXT = {
  1: "送信済み",
  2: "送信エラー",
  3: "予約済み",
}

export const ADMIN_STATUS = [
  { value: "", label: "すべて"},
  { value: "1", label: "有効"},
  { value: "2", label: "無効"},
]

export const ADMIN_STATUS_TEXT = {
  1: "有効",
  2: "無効",
}

// Dictation Course Types
export const DICTATION_COURSE_TYPES = [
  { value: "score", label: "スコア例"},
  { value: "part", label: "パート攻略"},
  { value: "custom", label: "カスタム"},
]

export const DICTATION_COURSE_TYPE_TEXT = {
  "score": "スコア例",
  "part": "パート攻略", 
  "custom": "カスタム",
}

// Countries for sentence audio
export const COUNTRIES = [
  { value: "", label: "選択してください"},
  { value: "アメリカ", label: "アメリカ"},
  { value: "イギリス", label: "イギリス"},
]

export const COUNTRY_TEXT = {
  "アメリカ": "アメリカ",
  "イギリス": "イギリス",
}

// Word Types for word management
export const WORD_TYPES = {
  "名": "名詞",
  "動": "動詞",
  "形": "形容詞",
  "副": "副詞",
  "前": "前置詞",
  "接": "接続詞",
  "代": "代名詞",
  "冠": "冠詞",
  "間": "間投詞",
  "助": "助動詞",
  "句動": "句動詞",
  "熟語": "熟語",
  "慣用": "慣用句"
}

// Word Levels for word management
export const WORD_LEVELS = {
  600: "600",
  730: "730", 
  860: "860",
  990: "990"
}
